import './DiagnosticsWatcher.scss';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CopyText } from './text';
import { getDiagnostics } from '@sonar-software/sonar-core';
import { SonarModal } from './modals';
import { useOnMount } from '@hooks';
import React, { useCallback, useEffect, useState } from 'react';
export const DiagnosticsWatcher = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [diagnosticSummary, setDiagnosticSummary] = useState();
    const [diagnosticUnlockKeypresses, setDiagnosticUnlockKeypresses] = useState(0);
    const showModal = useCallback(() => {
        setIsModalVisible(true);
    }, []);
    const hideModal = useCallback(() => {
        setIsModalVisible(false);
    }, []);
    useOnMount(() => {
        const listener = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key === 'F1') {
                setDiagnosticUnlockKeypresses((prev) => prev + 1);
            }
            else {
                setDiagnosticUnlockKeypresses(0);
            }
        };
        window.addEventListener('keydown', listener);
        return () => {
            window.removeEventListener('keydown', listener);
        };
    });
    useEffect(() => {
        if (isModalVisible) {
            return;
        }
        if (diagnosticUnlockKeypresses >= 3) {
            setDiagnosticUnlockKeypresses(0);
            getDiagnostics().then((response) => {
                if (response && response.data) {
                    setDiagnosticSummary(response.data.summary);
                }
            });
            showModal();
        }
    }, [diagnosticUnlockKeypresses, isModalVisible, showModal]);
    return (React.createElement(SonarModal, { centered: true, className: 'diagnostics-modal', footer: [
            React.createElement(CopyText, { displayText: COPY_SPECIFIC.COPY_TO_CLIPBOARD, key: 'clipboard', text: diagnosticSummary }),
            React.createElement(Button, { key: 'ok', onClick: hideModal, type: 'primary' }, COPY_SPECIFIC.OK)
        ], onCancel: hideModal, onOk: hideModal, open: isModalVisible, title: COPY_SPECIFIC.DIAGNOSTICS },
        React.createElement("div", { className: 'diagnostics-container' },
            React.createElement("textarea", { id: 'diagnostics-summary', readOnly: true, value: diagnosticSummary }))));
};
